





import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "dashboard-layout",
  components: {},
})
export default class DashboardLayout extends Vue {}
